import store from "../store/configureStore";

declare global {
  interface Window {
    ErrorLoggerService: (category?: string, ...rest: unknown[]) => void;
  }
}

const ACTION_TYPE = "#app/ERROR_LOG/CATCH";

interface ErrorLogAction {
  type: string;
  payload: string;
}

const ErrorLoggerService = (
  category: string = "APP",
  ...rest: unknown[]
): void => {
  const action: ErrorLogAction = {
    type: ACTION_TYPE,
    payload: [ "ErrorLoggerService: ", category, ...rest ].join()
  };
  store.dispatch(action);

  window["console"]["error"](category, ...rest); // eslint-disable-line dot-notation
};

window.ErrorLoggerService = ErrorLoggerService;

export default ErrorLoggerService;
